import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ac-cale',
  templateUrl: './ac-cale.component.html',
  styleUrls: ['./ac-cale.component.scss']
})
export class AcCaleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
